import { INetworkMenuList } from 'interfaces/UserNftAndToken/userNftToken';

const NetworkMenuList = ({
  getNfts,
  getTokens,
  networkName,
  setIsNetworkMenuVisible,
  isLastOnTheList = null,
  setUserNetworkName,
}: INetworkMenuList) => {
  const handleSelectedNetwork = async (userNetwork: string) => {
    setIsNetworkMenuVisible(false);
    setUserNetworkName(networkName);
    await getNfts(null, userNetwork);
    await getTokens(null, userNetwork);
  };
  return (
    <div
      onClick={() => handleSelectedNetwork(networkName.toLowerCase())}
      className={`h-[34px] ${
        isLastOnTheList ? '' : 'border-b'
      } cursor-pointer flex items-center  py-2 border-fade border-bottom`}
      key={networkName}
    >
      {networkName}
    </div>
  );
};
export default NetworkMenuList;
